import { Routes, Route } from 'react-router-dom';
import { DashboardLayout } from '@/layouts/DashboardLayout';
import { AuthLayout } from '@/layouts/AuthLayout';
import { ProtectedRoute } from '@/components/common/ProtectedRoute';
import { AdminRoute } from '@/components/common/AdminRoute';
import { LoginPage } from '@/pages/auth/LoginPage';
import { DashboardPage } from '@/pages/dashboard/DashboardPage';
import { UsersPage } from '@/pages/users/UsersPage';
import { OnboardingPage } from '@/pages/onboarding/OnboardingPage';
import { ProfilePage } from '@/pages/ProfilePage';
import { SettingsPage } from '@/pages/settings/SettingsPage';
import { SimpleFormPage } from '@/pages/SimpleFormPage';
import { ComprehensiveFormPage } from '@/pages/ComprehensiveFormPage';
import { NotFoundPage } from '@/pages/NotFoundPage';
import PlayerList from './pages/playerManagement/PlayerList';
import PlayerProfile from './pages/playerManagement/PlayerProfile';
import { TableList } from './pages/gameManagement/TableList';
import { TableEdit } from './pages/gameManagement/TableEdit';
import GameRoundHistoryComp from './pages/gameManagement/GameRoundHistory';
import AllBetsPage from './pages/gameManagement/AllBetsPage';
import SuspiciousBetsPage from './pages/gameManagement/SuspiciousBetsPage';
import DailyRevenueReport from './pages/reports/DailyRevenue';
import PlayerProfitLossPage from './pages/reports/PlayerProfitLossPage';
import GameProfitLossPage from './pages/reports/GameProfitLossPage';
import WithdrawalSummaryReport from './pages/transactions/withdrawals/WithdrawalSummary';
import PlayerComplaints from './pages/playerManagement/PlayerComplaints';
import ActivityLogs from './pages/logs/ActivityLogs';
import DepositWithdrawalRequest from './pages/transactions';

export function App() {
  return (
    <Routes>
      {/* Auth Routes */}
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<LoginPage />} />
      </Route>

      {/* Protected Routes */}
      <Route element={<ProtectedRoute />}>
        <Route element={<DashboardLayout />}>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/players" element={<PlayerList />} />
          <Route path="/players/profile/:playerId" element={<PlayerProfile />} />

          {/* Game routes */}
          <Route path="/game/tables" element={<TableList />} />
          <Route path="/game/table-edit" element={<TableEdit />} />
          <Route path="/game/round-history" element={<GameRoundHistoryComp />} />

          {/* Bet management routes */}
          <Route path="/bets/all" element={<AllBetsPage />} />
          <Route path="/bets/suspicious" element={<SuspiciousBetsPage />} />

          {/* Payment routes */}
          <Route path="/payments/deposit-withdraw" element={<DepositWithdrawalRequest />} />

          {/* Reports routes */}
          <Route path="/reports/daily-revenue" element={<DailyRevenueReport />} />
          <Route path="/reports/player-profit-loss" element={<PlayerProfitLossPage />} />
          <Route path="/reports/game-profit-loss" element={<GameProfitLossPage />} />
          <Route path="/reports/transaction-history" element={<WithdrawalSummaryReport />} />

          {/* supports & logs */}
          <Route path="/support/complaints" element={<PlayerComplaints />} />
          <Route path="/support/logs" element={<ActivityLogs />} />

          {/* Logged in user profile */}
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/onboarding" element={<OnboardingPage />} />

          {/* Settings Routes */}
          <Route path="/settings" element={<SettingsPage />} />

          {/* Form Examples */}
          <Route path="/forms" element={<SimpleFormPage />} />
          <Route path="/forms/comprehensive" element={<ComprehensiveFormPage />} />

          {/* Admin Routes */}
          <Route element={<AdminRoute />}>
            <Route path="/users" element={<UsersPage />} />
          </Route>
        </Route>
      </Route>

      {/* 404 */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
